import { z } from 'zod';

/**
 * Validated, typed access to the client environment. Only `VITE_`-prefixed
 * values reach the browser bundle. Fails fast with a clear message if misconfigured.
 *
 * Prefer the new Supabase **publishable** key (`sb_publishable_…`). The legacy
 * `anon` JWT is still accepted as a fallback during migration.
 */
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url('VITE_SUPABASE_URL must be a valid URL'),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1).optional(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1).optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  • ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(
    `Invalid environment configuration.\n${issues}\n\n` +
      'Copy .env.example to apps/web/.env.local and fill in your Supabase project values.',
  );
}

const publishableKey =
  parsed.data.VITE_SUPABASE_PUBLISHABLE_KEY ?? parsed.data.VITE_SUPABASE_ANON_KEY;

if (!publishableKey) {
  throw new Error(
    'Missing Supabase client key. Set VITE_SUPABASE_PUBLISHABLE_KEY (publishable key) in apps/web/.env.local.',
  );
}

export const env = {
  supabaseUrl: parsed.data.VITE_SUPABASE_URL,
  supabasePublishableKey: publishableKey,
} as const;
